<div
  class="side-modal-overlay"
  [style.--layer]="layer"
  (click)="closeModal()"
  *ngIf="opened"
></div>
<div
  [ngClass]="{ 'side-modal-container': true, opened: opened }"
  [class]="size"
  [style.left]="left"
  [style.width]="widthString"
  [style.--layer]="layer"
  #modalRef
>
  <div class="side-modal-header {{ headerState }}">
    <ng-content select="[title]" />
    <app-cross-icon
      height="20px"
      width="20px"
      color="var(--gray-600)"
      (click)="closeModal()"
      class="clickable"
    />
  </div>
  <div class="side-modal-body">
    <ng-content select="[body]" />
  </div>
  <div class="side-modal-footer">
    <ng-content select="[footer]" />
  </div>
</div>
